import qs from 'qs'
import axios from 'axios'

import {
	mapActions,
	mapMutations
} from 'vuex'

import {
	Modal,
	Input,
	DIV,
	Switch
} from 'iview'

export default {
	data() {
		return {
			headerWidth: 0
		}
	},
	setup() {
		// 切换主题方式1：修改全局CSS变量
		let changeTheme = (color, copigmentation, hue) => {
			document.documentElement.style.setProperty("--mainColor", color); //给变量设置对应颜色
			document.documentElement.style.setProperty("--complementaryColors", copigmentation); //给变量设置对应颜色
			document.body.setAttribute('theme', color);
			document.body.setAttribute('hue', hue);
		};
		return {
			changeTheme
		};
	},
	methods: {
		...mapActions([
			'getNavLogo',
			'getFooterLogo',
			'getGeneralSetting',
			'getSubjectColor',
			'getIsLogining',
			'getCustomer',
			'getsAvatar',
			'getChannelInfo'
		]),
		splitArrayAt(arr, index) {
			if (index < 0 || index > arr.length) {
				throw new Error('Index out of bounds');
			}
			return {
				firstPart: arr.slice(0, index),
				secondPart: arr.slice(index)
			};
		},
		showNav(list) {
			if (this.$refs.nav) {
				let totalWidth = window.innerWidth > 1200 ? window.innerWidth - 460 : 740;
				let itemsPerRow = 0;
				let currentWidth = 0;

				this.headerWidth = totalWidth
				// console.log('totalWidth-------', totalWidth)

				list.forEach(item => {
					currentWidth += item.barName.length * 14 + 26;
					if (currentWidth <= totalWidth - 54) {
						itemsPerRow++;
					}
				});

				// console.log(`每行最多可容纳 ${itemsPerRow} 个元素`);
				if (itemsPerRow >= list.length) {
					this.navList = list
				} else {
					this.moreNav = this.splitArrayAt(list, itemsPerRow);
					this.moreNav.firstPart.push({
						barName: '更多',
						overtop: true,
						barStatus: 1,
						linkType: 1,
						link: ''
					})
					// console.log(this.moreNav)
				}
			}

		},
		getNav() {
			var element = document.getElementsByTagName('html')[0]
			// var element = document.getElementById('app')
			// element.style.display = 'none'
			// element.style.display = 'none'

			this.$Loading.config({
				color: this.$store.state.user.subjectColor.mainColor
			});
			this.$Loading.start();
			this.$post(this.domain.dataRealization + 'barSetup/getBarList', qs.stringify({
					channelCode: window.channel,
				}))
				.then((res) => {
					// element.style.display = 'block'
					this.$Loading.finish();

					this.navList = []
					res.data.content.map(el => {
						if (el.barStatus == 1) {
							this.navList.push(el)
						}
					})

					this.navList.push({
						barName: '数品案例库',
						setupType: 100,
						link: 'caseLibrary',
						linkType: 'case',
						barStatus: 1
					})

					this.navList.push({
						barName: '入表咨询服务',
						setupType: 101,
						link: 'qA',
						linkType: 'case',
						barStatus: 1
					})

					this.navList.push({
						barName: '数据产品设计',
						setupType: 102,
						link: 'productDesignIntroduce',
						linkType: 'case',
						barStatus: 1
					})

					// console.log(this.navList)
					this.navList.map(el => {
						if (el.linkType != 1) {
							// else if (el.setupType == 2) el.link = 'dataEvaluationIntroduction'
							// else if (el.setupType == 3) el.link = 'dataValuationIntroduction'
							// else if (el.setupType == 4) el.link = 'dataDiscoveryIntroduction'
							// else if (el.setupType == 5) el.link = 'newsInformation'
							// else if (el.setupType == 6) el.link = 'aboutUs'

							if (el.setupType == 1) {
								el.link = 'Home'
							} else if (el.setupType == 2) {
								if (el.groupId == 1) {
									el.link = 'valuationProduct'
								} else if (el.groupId == 2) {
									el.link = 'diagnoseProduct'
								} else if (el.groupId == 3) {
									el.link = 'autoGeneratedBP'
								} else if (el.groupId == 4) {
									el.link = 'projectAnalysis'
								} else if (el.groupId == 7) {
									el.link = 'dataProduct'
								} else if (el.groupId == 6) {
									el.link = 'funds'
								}

							} else if (el.setupType == 4) {
								el.link = 'dataDiscoveryIntroduction'
							} else if (el.setupType == 5) {
								el.link = 'newsInformation'
							} else if (el.setupType == 6) {
								el.link = 'aboutUs'
							}
						}



					})

					this.showNav(this.navList)

					if (res.data.code == '401') {
						var isLogining = true
						this.getIsLogining({
							isLogining
						})
					}

				});
		},
		getLogo() {
			this.$post(this.domain.dataRealization + 'pageSetup/getPageSetup', qs.stringify({
					channelCode: window.channel,
					setupType: 7
				}))
				.then((res) => {
					var setupContent = JSON.parse(res.data.content.setupContent)
					const navLogo = setupContent.webLogo
					const footerLogo = setupContent.footerLogo
					const generalSetting = setupContent
					this.getGeneralSetting({
						generalSetting
					})

					const info = {
						channelName: res.data.content.channelName,
						channelShortName: res.data.content.channelShortName
					}

					this.getChannelInfo({
						info
					})

					for (var i = 0; i < setupContent.themeColor.length; i++) { //设置主题色
						if (setupContent.themeColor[i].checked) {


							if (setupContent.subjectColor.mainColor) {
								var subjectColor = {
									mainColor: setupContent.subjectColor.mainColor,
									complementaryColors: setupContent.subjectColor.complementaryColors,
									hue: setupContent.themeColor[i].hue
								}

							} else {
								var subjectColor = setupContent.themeColor[i]
							}
							this.getSubjectColor({
								subjectColor
							})

							this.changeTheme(subjectColor.mainColor, subjectColor.complementaryColors, subjectColor.hue) //设置主题色
							// console.log('主题色----', setupContent.themeColor[i].mainColor)
							break
						}
					}

				});
		},
		getCustomerInfo() { //查用户个人信息
			this.$post(this.domain.dataRealization + 'dataCustomer/getCustomerInfo', qs.stringify({}))
				.then((res) => {
					const data = res.data.content
					const headPortrait = res.data.content.headerAddr ? this.domain.testUrl + this.domain.dataRealization + res
						.data.content.headerAddr : ''
					this.getCustomer({
						data
					})

					this.getsAvatar({
						headPortrait
					})


				});
		}



	}
}
